import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

const WS_URL = process.env.REACT_APP_WS_URL || 'http://localhost:8080/ws';

export function createStompClient(roomToken, linkToken, onMessage, onConnected, onDisconnected) {
  const client = new Client({
    webSocketFactory: () => new SockJS(WS_URL),
    connectHeaders: {
      Authorization: `Bearer ${roomToken}`,
    },
    reconnectDelay: 3000,
    onConnect: () => {
      // Subscribe to this room's topic
      client.subscribe(`/topic/chat/${linkToken}`, (frame) => {
        try {
          const msg = JSON.parse(frame.body);
          onMessage(msg);
        } catch (e) {
          console.error('Failed to parse message', e);
        }
      });

      // Announce join
      client.publish({
        destination: `/app/chat/${linkToken}/join`,
        body: JSON.stringify({}),
      });

      onConnected?.();
    },
    onDisconnect: () => {
      onDisconnected?.();
    },
    onStompError: (frame) => {
      console.error('STOMP error', frame);
    },
  });

  return client;
}

export function sendMessage(client, linkToken, content) {
  if (!client?.connected) return false;
  client.publish({
    destination: `/app/chat/${linkToken}`,
    body: JSON.stringify({ content, type: 'MESSAGE' }),
  });
  return true;
}

export function sendLeave(client, linkToken) {
  if (!client?.connected) return;
  client.publish({
    destination: `/app/chat/${linkToken}/leave`,
    body: JSON.stringify({}),
  });
}
